<template>
  <div
    v-if="show || !isMobileView"
    class="calico-drawer"
  >
    <slot />
  </div>
</template>
<script lang="js">

export default {
  name: 'CalicoDrawer',
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isMobileView: window.innerWidth <= 729
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobileView = window.innerWidth <= 729;
    },
  },
}
</script>

<style lang="scss">
.calico-drawer {
  @include inset-space($space-large);
  @include stack-space($space-medium);
  flex: 1;
  width: 300px;
  min-width: 300px;
  background: $color-background-primary;
  z-index: $z-index-drawer;
  overflow: auto;
  scrollbar-width: none;
  @media (max-width: $mobile-breakpoint-max-width) {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
  }
}
</style>
